<div class="db-edit-original-ip">
  <h2 class="mb5">Edit server IP</h2>
  <p class="mb25">You can always edit the server IP of your website when needed.</p>
  <div class="ds-input-wrap">
    <span class="ds-input-label">Original server IP</span>
    <input type="text" class="ds-input"
           placeholder="{{originalRecord?.value}}"
           [value]="originalRecord?.value"
           [formControl]="originalRecord"
           [ngClass]="{'error': originalRecord?.invalid && originalRecord?.touched}">
    <span *ngIf="originalRecord?.invalid && originalRecord?.touched" class="ds-input-error-msg">Invalid IPv4 address</span>
    <span class="ds-input-desc">Use your DNS management service to double check.</span>
  </div>

  <div class="db-edit-original-ip-footer mt30">
    <div>If you’re having difficulties setting up Cloudflare,<br/><a class="text-underline" (click)="openChat()">contact our customer care team</a> for assistance.</div>
    <a class="ds-btn-green" [ngClass]="{'ds-btn-disabled': loading || originalRecord?.value === originalIp}"
       (click)="updateOriginalIp()" >
      <span *ngIf="!loading">Update</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </a>
  </div>

</div>
